import { mount } from 'svelte'
import ContactForm from 'shared/storefront/ContactForm.svelte'

export default (target, props) => mount(ContactForm, { target, props })

